import { render, staticRenderFns } from "./BasicDeleteTeamTournament.vue?vue&type=template&id=451f08e6&scoped=true"
import script from "./BasicDeleteTeamTournament.vue?vue&type=script&lang=js"
export * from "./BasicDeleteTeamTournament.vue?vue&type=script&lang=js"
import style0 from "./BasicDeleteTeamTournament.vue?vue&type=style&index=0&id=451f08e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451f08e6",
  null
  
)

export default component.exports